import { observable } from "mobx";
import { Type } from "class-transformer";
import DistributorPaymentRequestType from "./distributorPaymentRequestType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class SearchDistributorsIssuedPaymentRequestsRequest {
  /**
   * Number of records to be selected.
   * @example
   * 20
   */
  @observable
  limit?: number;

  @observable
  offset?: number;

  @observable
  @Type(() => Date)
  validSinceDate?: Date;

  @observable
  @Type(() => Date)
  validUntilDate?: Date;

  @observable
  variableSymbol?: number;

  @observable
  type?: DistributorPaymentRequestType;
}
